import { render, staticRenderFns } from "./dayiConsult.vue?vue&type=template&id=46eaaff0&scoped=true&"
import script from "./dayiConsult.vue?vue&type=script&lang=js&"
export * from "./dayiConsult.vue?vue&type=script&lang=js&"
import style0 from "./dayiConsult.vue?vue&type=style&index=0&id=46eaaff0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46eaaff0",
  null
  
)

export default component.exports